if (!customElements.get('product-info-tabs')) {
  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-info-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.product-info-tabs__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          var isMobile = window.matchMedia('(max-width: 749px)').matches;
          var isCurrentlyOpen = tab.getAttribute('aria-selected') === 'true';
          if (isMobile && isCurrentlyOpen) {
            this.select(null);
          } else {
            this.select(tab.dataset.tab);
          }
        });
      });
    }

    select(name) {
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', tab.dataset.tab === name ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const isOpen = panel.dataset.panel === name;
        panel.classList.toggle('is-open', isOpen);
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
}
